import { Pipe, PipeTransform } from '@angular/core';
import { Tariff } from '../../../tariffs/tariff.model';

@Pipe({
  name: 'uniqueTariffs',
  standalone: true,
})
export class UniqueTariffsPipe implements PipeTransform {
  // by design WIRED and WIRELESS tariffs absolute same and on some cases need show only 1 of them
  // and chose WIRED and WIRELESS on next step
  transform(tariffs: Tariff[] | null): Tariff[] {
    if (!tariffs) {
      return [];
    }
    return tariffs.filter((tariff, index, arr) => index === arr.findIndex(t => t.periodPrice === tariff.periodPrice
      && t.periodUnit === tariff.periodUnit
      && t.name === tariff.name
      && t.tariffType === tariff.tariffType));
  }
}
